import { useMutation } from '@tanstack/react-query';
import { tasksRepo } from '@/constants/providers';

export const useUpdateTask = () =>
  useMutation<unknown, unknown, FormData>((data) => tasksRepo.updateTask(data));
